import React, { useEffect, useRef, useState } from "react";
import "./Home.css";
import profile from "../assets/profile.jpg";
import bio from "../assets/bio.png";
import contact from "../assets/contact.png";

function RevealSection({ children, className = "" }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const currentRef = ref.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
      },
      {
        threshold: 0.28
      }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    const handleHomeReset = () => {
      setVisible(false);
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          setVisible(true);
        });
      });
    };

    window.addEventListener("homeReset", handleHomeReset);

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
      window.removeEventListener("homeReset", handleHomeReset);
    };
  }, []);

  return (
    <section className={`home-section ${className} ${visible ? "visible" : "hidden"}`} ref={ref}>
      {children}
    </section>
  );
}

export default function Home() {
  return (
    <div className="home-container">
      <RevealSection className="hero">
        <img src={profile} alt="profile" className="hero-image" />

        <h1 className="hero-name">Ben Booganim</h1>

        <p className="hero-title">
          Computer Science Student
          <br />
          Arizona State University
          <br />
          Spring 2026 Graduate
        </p>
      </RevealSection>

      <RevealSection>
        <img src={bio} alt="bio icon" className="section-icon" />

        <h2>About Me</h2>

        <p>
          I am a Computer Science student at Arizona State University with a
          focus on software engineering, database systems, and machine
          learning. I enjoy building scalable systems and data-driven
          applications that solve real problems. My experience includes
          full-stack development, AI projects, and leadership roles that have
          strengthened my ability to collaborate and build impactful
          technology.
        </p>
      </RevealSection>

      <RevealSection>
        <img src={contact} alt="contact icon" className="section-icon" />

        <h2>Contact</h2>

        <div className="contact-info">
          <p>
            📧{" "}
            <a href="mailto:booganimben04@gmail.com">
              booganimben04@gmail.com
            </a>
          </p>

          <p>
            📱{" "}
            <a href="tel:4254354674">
              425-435-4674
            </a>
          </p>
        </div>
      </RevealSection>
    </div>
  );
}